<template lang="pug">

el-dialog#modal-cancelar-monitoramentos(
    width='700px',
    :visible.sync='mostrar',
    :before-close='fechar',
    :close-on-click-modal='false',
    :close-on-press-escape='false',
    :destroy-on-close='true',
    close='fechar'
)
    span(slot='title')

        h1.font-weight-bold
            i(class='mdi mdi-alert-circle warning')
            span Cancelar monitoramentos e editar

    div#corpo()
        strong Deseja cancelar os monitoramentos ativos e realizar a edição do território?

        p Ao final da edição você poderá criar novamente os monitoramentos a partir dos novos dados

    div(slot='footer')
        .buttons
            BaseButton(size='large', @click='fechar')
                | Sair
            BaseButton(
                type='primary',
                size='large',
                @click='confirmar'
            )
                | Cancelar monitoramentos e editar

</template>
        
<script>
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

export default {
    name: 'ModalCancelarMonitoramento',
    components: {
        BaseButton
    },
    emits: ['fechar', 'confimar'],
    props: {
        mostrar: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            edicao: null
        };
    },

    mounted() {

    },

    watch: {

    },

    methods: {
        fechar() {
            this.$emit('fechar');
        },

        confirmar() {
            this.$emit('confimar');
        }
    }
};
</script>
        
<style lang="scss">
#modal-cancelar-monitoramentos {
    border-radius: 5px;

    .el-dialog__header {
        background-color: #e9e9e9;
        padding-bottom: 20px;
    }

    .el-dialog__body {
        padding: 30px 20px 30px;

        .inline {
            .el-form-item__content {
                text-align: end;
            }
        }

        h3 {
            font-size: 16px;
        }
    }

    .edicao {
        margin-top: 30px;
    }

    .edicao .el-radio__label {
        margin-right: 10px;
    }

    .table-territorios {
        margin: 30px 0;
    }

    .el-dialog__footer {
        .buttons {
            display: flex;
            justify-content: space-between;
        }
    }

}
</style>
